import { createTheme } from '@mui/material';
import shadows from './shadows';
import typography from './typography';
import BreakPoints from './breakPoints';

// MUI theme нь CSS variables-аас өнгө уншина.
// globals.css дээр :root { --primary: ...; } тодорхойлсон утгуудыг
// Tailwind болон MUI хоёулаа ашиглана.
const theme = createTheme({
    breakpoints: {
        values: BreakPoints,
    },
    palette: {
        primary: {
            main: 'hsl(var(--primary))',
            dark: 'hsl(var(--primary-hover))',
            contrastText: 'hsl(var(--primary-foreground))',
        },
        secondary: {
            main: 'hsl(var(--secondary))',
            dark: 'hsl(var(--secondary-hover))',
            contrastText: 'hsl(var(--secondary-foreground))',
        },
        background: {
            default: 'hsl(var(--background))',
            paper: 'hsl(var(--card))',
        },
        text: {
            primary: 'hsl(var(--foreground))',
            secondary: 'hsl(var(--muted-foreground))',
        },
        error: {
            main: 'hsl(var(--destructive))',
        },
    },
    shadows,
    typography,
    components: {
        MuiButton: {
            styleOverrides: {
                containedPrimary: {
                    background: 'hsl(var(--primary))',
                    color: 'hsl(var(--primary-foreground))',
                    borderRadius: 6,
                    '&:hover': {
                        background: 'hsl(var(--primary-hover))',
                    },
                },
                containedSecondary: {
                    background: 'hsl(var(--secondary))',
                    color: 'hsl(var(--secondary-foreground))',
                    '&:hover': {
                        background: 'hsl(var(--secondary-hover))',
                    },
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    background: 'hsl(var(--card))',
                    borderRadius: 12,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                filledError: {
                    color: '#fff',
                    '& .MuiAlert-icon': { color: '#fff' },
                },
                filledWarning: {
                    color: '#fff',
                    '& .MuiAlert-icon': { color: '#fff' },
                },
                filledSuccess: {
                    color: '#fff',
                    '& .MuiAlert-icon': { color: '#fff' },
                },
                filledInfo: {
                    color: '#fff',
                    '& .MuiAlert-icon': { color: '#fff' },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'hsl(var(--primary))',
                    },
                },
            },
        },
    },
});

export default theme;
